import * as React from 'react';
import { ButtonTertiary } from 'ui/common/button';
import { ViewMode } from 'app/area/case/types-store';
import { MdArrowBack } from 'react-icons/md';

export const ToggleMode = ({ expandAll, expandText, collapseText, changeViewMode }) => {

  const handleToggle = event => {
    event.preventDefault();
    expandAll ?
      changeViewMode(ViewMode.tabs)
      :
      changeViewMode(ViewMode.scroll);
  };
  return expandAll ?
    <ButtonTertiary onClick={handleToggle}>{collapseText}</ButtonTertiary>
    :
    <ButtonTertiary onClick={handleToggle}>{expandText}</ButtonTertiary>;
};

export const ToggleOpen = ({
  styles,
  onClick,
  label,
  hasError
}) => <button className={`${styles.mobileToggle} ${!!hasError && styles.hasError}`} type="button" onClick={onClick}>
    <div>
      <span className={styles.btnArrowLeft}><MdArrowBack /></span>
      <span className={styles.btnLabel}>{label}</span>
    </div>
  </button>;
